import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState, SlidePanelContent, SlidePanelPosition, SlidePanelSide } from '../../../store';
import { setSlidePanelPositionAndContent } from '../../../store/actions/timelineActions';
import SidePanel, { SidePanelActions, SidePanelProps } from './SidePanel';

const mapStateToProps: MapStateToProps<SidePanelProps, any, ApplicationState> = (state: ApplicationState, _) => ({
  position: state.timeline.sidePanelPosition,
  content: state.timeline.sidePanelContent,
  side: state.timeline.sidePanelSide
});

const mapDispatchToProps: MapDispatchToProps<SidePanelActions, any> = (dispatch: Dispatch) => ({
  closePanel: () =>
    dispatch(setSlidePanelPositionAndContent(SlidePanelPosition.Closed, SlidePanelContent.Empty, SlidePanelSide.Left))
});

export const SidePanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SidePanel);



// WEBPACK FOOTER //
// ./src/components/common/sidePanel/SidePanelContainer.ts